import '@sendbird/uikit-react/dist/index.css';
import { type FC, useMemo } from 'react';
import { type CoreAdminProps } from 'ra-core';
import { Admin as KitAdmin } from '../components/admin/admin';
import { AccessDenied } from '../components/admin/access-denied';
import { AuthCallback } from '../components/admin/authentication';
import { Error as AdminError } from '../components/admin/error';
import { Loading } from '../components/admin/loading';
import { NotFound } from '../components/admin/not-found';
import { Ready } from '../components/admin/ready';
import {
  AdminResources,
  useAdminResourcePermissions,
} from '../resources/AdminResources';
import { LoginRedirect } from './login/LoginRedirect';

export const Admin: FC<CoreAdminProps> = (props) => {
  const resourcePermissions = useAdminResourcePermissions();
  // Stable children: ra-core re-registers every resource whenever the `<Admin>` children change
  const resources = useMemo(
    () => AdminResources(resourcePermissions),
    [resourcePermissions]
  );

  return (
    <KitAdmin
      {...props}
      accessDenied={AccessDenied}
      authCallbackPage={AuthCallback}
      catchAll={NotFound}
      disableTelemetry
      error={AdminError}
      loading={Loading}
      loginPage={LoginRedirect}
      ready={Ready}
      title="Moonstar Admin Portal"
    >
      {resources}
    </KitAdmin>
  );
};
